import { AxiosError } from 'axios';
import instance from '../config/axios';

export const getUnreadNotifications = async (token: string) => {
  try {
    const response = await instance.get(`/api/v1/patient/notifications/inbox`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response;
  } catch (err) {
    console.error(err);
    return (err as AxiosError).response?.status as number;
  }
};
